import { render, staticRenderFns } from "./Qom.vue?vue&type=template&id=4c7679e8&scoped=true"
import script from "./Qom.vue?vue&type=script&lang=js"
export * from "./Qom.vue?vue&type=script&lang=js"
import style0 from "./Qom.vue?vue&type=style&index=0&id=4c7679e8&prod&lang=css"
import style1 from "./Qom.vue?vue&type=style&index=1&id=4c7679e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7679e8",
  null
  
)

export default component.exports